// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetCascadesResponse = App.Http.Responses.Cascade.GetCascadesResponse;
import GetCascadeResponse = App.Http.Responses.Cascade.GetCascadeResponse;
import StoreCascadeRequest = App.Http.Requests.Cascade.StoreCascadeRequest;
import UpdateCascadeRequest = App.Http.Requests.Cascade.UpdateCascadeRequest;
import GetCascadesRequest = App.Http.Requests.Cascade.GetCascadesRequest;
import BatchInsertUpdateCascadeResponse = App.Http.Responses.Cascade.BatchInsertUpdateCascadeResponse;
import BatchUpdateCascadeRequest = App.Http.Requests.Cascade.BatchUpdateCascadeRequest;
import BatchStoreCascadeRequest = App.Http.Requests.Cascade.BatchStoreCascadeRequest;
import BaseBatchDeleteRequest = App.Http.Requests.BaseBatchDeleteRequest;

class CascadeApi extends TenantBaseApi {
    /**
     * Get list of cascades
     *
     * - Request: GetCascadesRequest
     * - Response: GetCascadesResponse
     */
    async index(request: GetCascadesRequest): Promise<GetCascadesResponse> {
        return await this.get<GetCascadesResponse, GetCascadesRequest>("/cascades", {
            params: request,
        });
    }

    async show(cascadeId: string, request: GetCascadeResponse) {
        return await this.get<GetCascadeResponse, null>(`/cascades/${cascadeId}`, {
            params: request,
        });
    }

    /**
     * Store Cascade
     *
     * - Request: StoreCascadeRequest
     * - Response: GetCascadeResponse
     */
    async store(request: StoreCascadeRequest): Promise<GetCascadeResponse> {
        return await this.post<GetCascadeResponse, StoreCascadeRequest>("/cascades", request);
    }

    /**
     * Update Cascade
     *
     * - Request: UpdateCascadeRequest
     * - Response: GetCascadeResponse
     */
    async update(request: UpdateCascadeRequest, cascadeId: string): Promise<GetCascadeResponse> {
        return await this.patch<GetCascadeResponse, UpdateCascadeRequest>(`/cascades/${cascadeId}`, request);
    }

    /**
     * Batch Store Cascades
     *
     * - Request: BatchStoreCascadeRequest
     * - Response: BatchInsertUpdateCascadeResponse
     */
    async batchStore(request: BatchStoreCascadeRequest): Promise<BatchInsertUpdateCascadeResponse> {
        return await this.post<BatchInsertUpdateCascadeResponse, BatchStoreCascadeRequest>("/cascades/batch", request);
    }

    async batchUpdate(request: BatchUpdateCascadeRequest): Promise<BatchInsertUpdateCascadeResponse> {
        return await this.patch<BatchInsertUpdateCascadeResponse, BatchUpdateCascadeRequest>("/cascades/batch", request);
    }

    /**
     * Delete Cascade
     *
     * - Request: { id: string }
     * - Response: void
     */
    async destroy(cascadeId: string): Promise<void> {
        return await this.delete<null, void>(`/cascades/${cascadeId}`);
    }

    /**
     * Batch Delete Cascades
     *
     * - Request: BaseBatchDeleteRequest
     * - Response: void
     */
    async batchDelete(request: BaseBatchDeleteRequest): Promise<void> {
        return await this.delete<void, BaseBatchDeleteRequest>("/cascades/batch", { data: request });
    }
}

export const cascadeApi = new CascadeApi();
